import React, { useState } from "react";
import "../../page_content.css";

const Accommodation = () => {
  return (
    <div className="page-content-section">
      <h1 className="title">Accommodation</h1>
      <hr />
      <div className="page-content-container">
        <p>
          Being a fully residential program, the hostel facilities for the
          cadets consist of well-designed new dormitories. It is mandatory for
          all cadets to stay in the hostel. This way, the cadets get a feeling
          of things that will prepare them well for their career at sea.
        </p>
        <p>
          In line with industry standards, the college has built a
          well-furnished hostel that is managed by an experienced in-house
          warden. Each room is furnished with closets, study table, chairs,
          coats with beds etc. and houses are two cadets. Realizing the
          importance of good health and physical fitness of a merchant navy
          officer, a well-equipped modern gymnasium has been set up with
          well-qualified and experienced instructors.
        </p>

        <div>
          <h2 className="innerpage-heading">Highlights of Hostel facilities</h2>
          <ul className="page-content-lists">
            <li>Hostel building for boys and girl cadets.</li>
            <li>24-hours fresh water supply.</li>
            <li>Hot water supply during morning routines.</li>
            <li>
              Recreation rooms on every floor and projection television at the
              hostel.
            </li>
            <li>
              Coolers with Aquaguard in every wing of the hostel and dining
              hall.
            </li>
            <li>Well-furnished rooms with complete bedding.</li>
            <li>24-hours manned by hostel boys and wardens.</li>
            <li>A well-equipped modern gymnasium with trained instructors.</li>
            <li>
              Medical inspection room with well-qualified doctors. For emergency
              purposes, tie-up with nearby hospital with ambulance facility.
            </li>
            <li>Mess facility with high-quality and nutritious food.</li>
            <li>
              For maintaining discipline in the hostel, various methods are used
              like awarding and deducting credit marks and night muster.
            </li>
            <li>
              Every day, the evening is utilized for haircut and dress
              inspection with parade drills.
            </li>
            <li>
              Holidays are utilized for various extra and cocurricular
              activities like marathons, industrial visits, picnics and
              trekking.
            </li>
            <li>Laundry facility twice a week.</li>
          </ul>
        </div>

        <div>
          <h2 className="innerpage-heading">Hostel Curriculum </h2>

          {/* table 1 */}
          <table className="page-content-table"   style={{ width: "min(95%, 1100px)" }}>
            <thead>
              <tr>
                <th className="table-heading" colSpan="3">
                  Routine
                </th>
              </tr>
              <tr className="table-subheading">
                <th>Days </th>
                <th>Timing </th>
                <th>Events Daily</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Monday To Friday Daily </td>
                <td>08:30 Hrs. 07:40 To 0805 Hrs.</td>
                <td className="vertical-cell">
                  Daily Uniform Inspection - Except Holidays, Saturday & Sundays
                  <br />
                  Daily Cabin Checking/Inspection
                </td>
              </tr>
              <tr>
                <td>Thursday</td>
                <td>On Or Before 14:00 Hrs.</td>
                <td>
                  Submission of Night off forms. Parents or Local guardian
                  should write an Email to: hod.hostel@manetpune.edu.in
                </td>
              </tr>
              <tr>
                <td>Friday </td>
                <td>After-16:30 Hrs.</td>
                <td>Issuing of Night off permission to Cadets.</td>
              </tr>
            </tbody>

            {/* sub-table 1 */}
            <thead>
              <tr className="table-subheading">
                <th colSpan="3">Mess Timing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Breakfast </td>
                <td>07:15 To 08:30 Hrs.</td>
                <td>Events Daily</td>
              </tr>
              <tr>
                <td>Lunch </td>
                <td>11:30 To 13:30 Hrs.</td>
                <td></td>
              </tr>
              <tr>
                <td>Snacks </td>
                <td>17:00 To 17:30 Hrs.</td>
                <td></td>
              </tr>
              <tr>
                <td>Dinner </td>
                <td>19:30 To 20:45 Hrs.</td>
                <td></td>
              </tr>
            </tbody>

            {/* sub-table 2 */}
            <thead>
              <tr className="table-subheading">
                <th colSpan="3">Gymnasium Timing</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Morning </td>
                <td>06:15 To 08:00 Hrs.</td>
                <td>Except Saturday, Sunday & Holidays</td>
              </tr>
              <tr>
                <td>Evening </td>
                <td>17:30 To 19:30 Hrs.</td>
                <td>Except Saturday, Sunday & Holidays</td>
              </tr>
            </tbody>

            {/* sub-table 3 */}
            <thead>
              <tr className="table-subheading">
                <th colSpan="3">PT & Parade - Monday to Friday (Batch Wise)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Morning Session </td>
                <td>06:15 To 07:15 Hrs.</td>
                <td>Except Saturday, Sunday & Holidays</td>
              </tr>
              <tr>
                <td>Evening Session </td>
                <td>17:30 To 19:15 Hrs.</td>
                <td>Except Saturday, Sunday & Holidays</td>
              </tr>
            </tbody>
          </table>

          {/* table 2 */}
          <table
            className="page-content-table"
            style={{ width: "min(95%, 1100px)" }}
          >
            <thead>
              <tr>
                <th className="table-heading" colSpan="3">
                  On-Campus Essential Services
                </th>
              </tr>
              <tr className="table-subheading">
                <th>Services</th>
                <th>Time </th>
                <th>Available </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Doctor's OPD </td>
                <td>20:00 To 21:00 Hrs.</td>
                <td>closed on Sunday</td>
              </tr>
              <tr>
                <td>Liberty</td>
                <td>09:00 To 20:00 Hrs.</td>
                <td>Saturday, Sunday & Holidays</td>
              </tr>
              <tr>
                <td>Gate Pass</td>
                <td>17:00 To 18:00 Hrs.</td>
                <td>
                  Gate Pass Will Be Issued Subject to Emergency & Case to Case
                  Basis. (On Working Days )
                </td>
              </tr>
              <tr>
                <td>Laundry Services</td>
                <td>17:00 To 19:00 Hrs.</td>
                <td>Every Day As Per Schedule</td>
              </tr>
            </tbody>
          </table>
          
        </div>
      </div>
    </div>
  );
};

export default Accommodation;
